import React, { useRef, useState } from 'react';
import { styled } from '@linaria/react';

import { useOutsideClick } from '../../hooks';

const DropdownContainer = styled.div`
  position: relative;
`;

const DropdownList = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  box-shadow: 10px 10px 30px rgb(32 54 70 / 10%);
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  padding: 8px 0;
  z-index: 1000;
  background-color: #fff;
  transition: all 0.2s ease;
  transform: scale(0.7, 0);
  transform-origin: top right;

  &.active {
    visibility: visible;
    opacity: 1;
    transform: scale(1, 1);
  }
`;

type DropdownProps = {
  button: (active: boolean) => React.ReactNode;
  children: React.ReactNode;
};

const Dropdown: React.FC<DropdownProps> = ({ button = () => null, children, ...rest }) => {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useOutsideClick({
    ref,
    handler: () => setActive(false),
  });

  return (
    <DropdownContainer
      {...rest}
      ref={ref}
    >
      <div onClick={() => setActive(!active)}>{button(active)}</div>

      <DropdownList className={active ? 'active' : ''}>{children}</DropdownList>
    </DropdownContainer>
  );
};

export default Dropdown;
